import React from 'react';
import { CornerUpLeft, Languages, Volume2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { router, AppRoute } from '@/lib/router';
import { useTranslation } from '@/contexts/I18nContext';
import { UILanguageSelector } from '@/components/shared/UILanguageSelector';
import { AccountSettings } from '@/components/settings';

export const SettingsPage: React.FC = () => {
  const { t } = useTranslation();

  const handleBackToHome = () => {
    router.navigate(AppRoute.HOME);
  };

  return (
    <div className="container mx-auto px-4 py-6 h-full flex flex-col">
      {/* Header */}
      <div className="flex items-center gap-4 mb-6">
        <Button
          onClick={handleBackToHome}
          variant="ghost"
          size="sm"
          className="gap-2"
        >
          <CornerUpLeft className="h-4 w-4" />
          {/* 返回主页 */}
        </Button>
        <div>
          <h1 className="text-2xl font-semibold">{t('settings.title')}</h1>
          <p className="text-sm text-muted-foreground">
            {t('settings.description')}
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto">
        <div className="grid gap-4 max-w-2xl">
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Languages className="h-5 w-5" />
                {t('settings.language')}
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-6">
              <div>
                <h3 className="text-sm font-medium mb-3">{t('settings.uiLanguage')}</h3>
                <p className="text-sm text-muted-foreground mb-4">
                  {t('ui.selectLanguageDescription')}
                </p>
                <UILanguageSelector
                  variant="select"
                  showFlag={true}
                  showNativeName={true}
                />
              </div>

              {/* <Separator />

              <div>
                <h3 className="text-sm font-medium mb-3">{t('ui.translationLanguageSettings')}</h3>
                <p className="text-sm text-muted-foreground mb-4">
                  配置默认的源语言和目标语言
                </p>
                <div className="text-sm text-muted-foreground">
                  {t('ui.comingSoon')}
                </div>
              </div> */}
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Volume2 className="h-5 w-5" />
                {t('settings.audio')}
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-muted-foreground">
                {t('ui.audioSettingsDescription')}
              </p>
              {/* TODO: 添加音频设备选择器 */}
              <div className="text-sm text-muted-foreground mt-4">
                {t('ui.comingSoon')}
              </div>
            </CardContent>
          </Card>

          {/* 账户设置 */}
          <AccountSettings />
        </div>
      </div>
    </div>
  );
}; 